import { X, ChevronsUpDown } from "lucide-react";

type TriggerControlsProps = {
  /** Whether there are any selected values */
  hasSelections: boolean;
  /** Whether the entire component is disabled */
  disabled: boolean;
  /** Callback when the clear all button is clicked */
  onClearAll: () => void;
};

/**
 * Control buttons for the multi-select trigger
 *
 * Contains the clear all button (when selections exist) and the
 * chevron indicator. Handles click events and keyboard accessibility.
 */
export function TriggerControls({
  hasSelections,
  disabled,
  onClearAll,
}: TriggerControlsProps) {
  const handleClearAll = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation();
    if ("key" in e && e.key !== "Enter" && e.key !== " ") return;
    if ("key" in e) e.preventDefault();
    onClearAll();
  };

  return (
    <div className="flex items-center gap-1">
      {/* Clear all button - only show when selections exist and not disabled */}
      {hasSelections && !disabled && (
        <span
          role="button"
          tabIndex={0}
          onClick={handleClearAll}
          onKeyDown={handleClearAll}
          className="cursor-pointer rounded p-1 hover:bg-gray-100"
          aria-label="Alle Auswahlen löschen"
        >
          <X size={16} />
        </span>
      )}

      {/* Chevron indicator */}
      <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
    </div>
  );
}
